import { Injectable } from '@angular/core';
import {
  StoreCategoriesStore,
  StoreImagesStore,
  StoreOrdersStore,
  StoreProductsStore,
  StoreVariationsStore,
  StoreConfigurationStore
} from '@boxx/store-core';
import { StoreCouponsStore } from './coupons/store-coupons.store';

@Injectable()
export class StorePageStore {
  constructor(
    public categoriesStore: StoreCategoriesStore,
    public imagesStore: StoreImagesStore,
    public ordersStore: StoreOrdersStore,
    public productsStore: StoreProductsStore,
    public variationsStore: StoreVariationsStore,
    public configurationStore: StoreConfigurationStore,
    public couponsStore: StoreCouponsStore,
  ) {}
}
